import Spinner from 'components/Spinner'
import NextImage, { ImageProps } from 'next/image'
import { useState } from 'react'
import { twMerge } from 'tailwind-merge'

const ImageWithLoad: React.FC<{ loadingClassName?: string } & ImageProps> = ({
  loadingClassName,
  ...imageProps
}) => {
  const [loaded, setLoaded] = useState(false)
  const [errored, setErrored] = useState(false)

  return (
    <div className="relative w-full h-full">
      <NextImage
        {...imageProps}
        onLoadingComplete={() => setLoaded(true)}
        onError={() => setErrored(true)}
      />

      {!loaded && !errored && (
        <div className={twMerge('flex w-full h-full', loadingClassName)}>
          <Spinner />
        </div>
      )}
    </div>
  )
}

export default ImageWithLoad
